
import { Component, Vue } from "vue-property-decorator";
import SolicitudReclamacionesForm from "@/components/Solicitud_Reclamaciones/SolicitudReclamacionesForm.vue";
import SolicitudReclamacionesResult from "@/components/Solicitud_Reclamaciones/SolicitudReclamacionesResult.vue";
import Reclamacion from "@/models/SolicitudReclamaciones/Reclamacion";
import WsdlService from "@/services/WsdlService";
import SolicitudReclamacionesModel from "@/models/SolicitudReclamaciones/SolicitudReclamacionesModel";
import GlobalConfig from "@/GlobalConfig";
import UmbracoApiService from "@/services/UmbracoApiService";

@Component({
    components: {
        SolicitudReclamacionesForm,
        SolicitudReclamacionesResult,
    },
})
export default class SolicitudReclamaciones extends Vue {
    public isLoading: boolean = false;
    public email: string = this.$store.state.user.correoElectronico1;
    public nombre: string = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
    public userId: string = this.$store.state.user.cedula;
    public labelData: SolicitudReclamacionesModel =
        new SolicitudReclamacionesModel();
    public processForm: boolean = false;
    public umbracoService: UmbracoApiService = new UmbracoApiService();
    public wsdlService: WsdlService = new WsdlService();
    public umbracoBaseUrl: string = GlobalConfig.UMBRACO_BASE_URL;

    public async mounted() {
        await this.getLabels();
    }
    public processComplaintForm(complaint: Reclamacion) {
        this.isLoading = true;
        this.wsdlService
            .postReclamacion(complaint)
            .then(() => {
                this.processForm = true;
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
    public getLabels() {
        this.umbracoService.getSolicitudReclamaciones().then((response) => {
            this.labelData = response;
        });
    }
}
